import api from "../../index";

export const GetFaqListApi = () => api.post('faq-list');
export const AddUpdateFaqApi = (data) => api.post('add-update-faq', data);
export const DeleteFaqApi = (data) => api.post('delete-faq', data);
export const ChangeFaqStatusApi = (data) => api.post('faq-status-change', data);